package app.footyguide.web.components.club

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*
import app.footyguide.core.theme.Club
import app.footyguide.web.components.Icons
import app.footyguide.web.components.LucideIcon
import app.footyguide.web.components.SafeImg
import app.footyguide.web.data.TeamHubData
import kotlinx.browser.window

/**
 * Resolves the primary fallback image source when a club quiz icon is missing or fails to load.
 */
fun resolveQuizFallbackSrc(club: Club): String = club.logoUrl

/**
 * Alefly Quiz Integration Card (shown only if club has an active quiz).
 */
@Composable
fun ClubQuizCard(club: Club, hubData: TeamHubData? = null) {
    if (!club.hasAleflyQuiz) return

    val strings = app.footyguide.core.locale.LocalStrings.current
    val quizTargetUrl = club.aleflyQuizUrl
    val quizIconUrl = club.aleflyIconUrl
    val title = hubData?.quizTitle ?: strings.clubQuizTitle.replace("{club}", club.name)
    val description = hubData?.quizDescription ?: strings.clubQuizSubtitle.replace("{club}", club.name)

    Div({ style { padding(0.px, 16.px, 20.px) } }) {
        Div({
            onClick { window.open(quizTargetUrl, "_blank") }
            style {
                backgroundColor(Color("#16181D"))
                borderRadius(16.px)
                padding(16.px)
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                justifyContent(JustifyContent.SpaceBetween)
                gap(14.px)
                cursor("pointer")
                property("box-shadow", "0 4px 12px rgba(22, 24, 29, 0.1)")
            }
        }) {
            Div({
                style {
                    width(52.px)
                    height(52.px)
                    minWidth(52.px)
                    borderRadius(14.px)
                    overflow("hidden")
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    justifyContent(JustifyContent.Center)
                    backgroundColor(Color("rgba(255, 255, 255, 0.06)"))
                }
            }) {
                SafeImg(
                    src = quizIconUrl,
                    fallbackSrc = resolveQuizFallbackSrc(club),
                    fallbackIcon = Icons.SHIELD,
                    fallbackSize = 28,
                    modifier = {
                        width(100.percent)
                        height(100.percent)
                        borderRadius(14.px)
                        property("object-fit", "cover")
                    }
                )
            }

            Div({ style { flex(1) } }) {
                Span({
                    style {
                        display(DisplayStyle.Block)
                        fontSize(16.px)
                        fontWeight(800)
                        color(Color("#FFFFFF"))
                        letterSpacing((-0.2).px)
                    }
                }) {
                    Text(title)
                }
                Span({
                    style {
                        display(DisplayStyle.Block)
                        marginTop(4.px)
                        fontSize(13.px)
                        color(Color("#A1A1AA"))
                        property("line-height", "1.35")
                    }
                }) {
                    Text(description)
                }
            }

            LucideIcon(Icons.CHEVRON_RIGHT, size = 20, color = "#FFFFFF")
        }
    }
}
